import React from 'react';
import { number, node, object, string, oneOfType } from 'prop-types';

import Paper from '@mui/material/Paper';

const PaperBox = ({ children, style, className, elevation, paperStyle }) => {
  const wrapperStyle = { padding: '0px', ...style };

  return (
    <div style={wrapperStyle}>
      <Paper className={className} elevation={elevation} style={paperStyle}>
        {children}
      </Paper>
    </div>
  );
};

PaperBox.propTypes = {
  children: node,
  style: object,
  className: oneOfType([string, object]),
  elevation: number,
  paperStyle: object,
};

PaperBox.defaultProps = {
  children: null,
  style: null,
  className: null,
  elevation: 1,
  paperStyle: null,
};

export default PaperBox;
